import React from 'react'
import { getMapApi } from '../../../Api/Utils/apiUtils'
import MapDetails from './MapDetails'

const ManageBusinessMap = ({lat, lng, size}) => {
    return (
        <MapDetails isMarkerShown 
        googleMapURL={getMapApi()}
        loadingElement={<div style={{ width: `100px` }} />}
        containerElement={<div style={{ height: `500px` }} />}
        mapElement={<div style={{ height: `100%` }} />} latt={lat && lat} lngg={lng && lng}
        size={size? size : 0} />
    )
}

export default ManageBusinessMap
